// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"dam-3"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 21V10C4 5.02944 8 2 12 2C16 2 20 5.02944 20 10V21H16V10H8V21H4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 21V10C4 5.02944 8 2 12 2C16 2 20 5.02944 20 10V21M4 21H3M4 21H8M20 21H21M20 21H16M8 10V21M8 10H16M8 10H4.25M8 21H9M16 10V21M16 10H19.75M16 21H15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M11 6H13","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-dam-3')
export default class Dam3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-3',
    }
  }
}
